import React, { useState, useEffect } from 'react';
import AgregarSiembraCampo from '../planeacionCampo/componentes/AgregarSiembraCampo';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import Verifiers from '../../../../utils/Verifiers.jsx';
import Post from '../../../../utils/Post';
import { get } from 'lodash';

const SiembraDirecta = () => {
    const [agregar, setagregar] = useState(false);
    const [registroEdicion, setregistroEdicion] = useState(null);
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [filtros, setfiltros] = useState({ flores: [], variedades: [], colores: [] });
    const [paginer, setpaginer] = useState({
        page: 1,
        per_page: 50,
        total_pages: 0,
        total: 0,
        semana: "",
        flor: "",
        variedad: "",
        color: ""
    });
    const [semanas, setsemanas] = useState([]);
    const [data, setdata] = useState([]);
    const headsTable = ['BLOQUE', 'S. SIEMBRA', 'S. TRASPLANTE', 'S. CORTE', 'C. CAMPO', 'GERMINACIÓN', 'DENSIDAD', 'METROS²', 'PLANTAS', 'RECUPERACIÓN', 'SEMILLAS', 'TALLOS', 'USUARIO'];
    const keys = ['bloque', 'semana_siembra', 'semana_trasplante', 'semana_corte', 'ciclo_campo', 'germinacion', 'densidad', 'metros2', 'plantas', 'recuperacion', 'semillas', 'tallos', 'usuario_nombre'];
    useEffect(() => {
        getRegistros();
    }, []);

    const cerrarYguardar = (guardar) => {
        if (guardar) getRegistros();
        setagregar(false);
        setregistroEdicion(null);
    }

    const getRegistros = async (pag = { ...paginer }) => {
        let resp = await Post('campo/v2/siembra/get', pag, 'POST', setloader);
        if (!resp.estatus) {
            Verifiers.activeDialog(setdialog, resp.msj, 'Error', 'error');
            return;
        }
        setdata(resp.data);
        setpaginer({ ...pag, total_pages: resp.total_pages, total: resp.data.total, semana: resp.semana_actual });
        setsemanas(resp.semanas);
        setfiltros({ flores: resp.flores, variedades: resp.variedades, colores: resp.colores });
    }
    return (
        <div className='vw-100 p-2 overflow bg-white p-1 dosis' style={{ height: "calc( 100vh - 60px)" }}>
            <div className='w-100 round-left-xxl gradient-small-black text-white text-300 p-1 ps-3 text-l'>
                <div className='row justify-content-between m-0 p-0 w-100'>
                    Siembra directa
                    <div className='col-auto text-dark scale-025 pointer bg-warning round-xxl text-bold ' onClick={() => setagregar(true)}>Agregar</div>
                </div>
            </div>

            <div className='row justify-content-evenly w-100 m-0 p-0 ps-1 pe-1'>
                <div className='bw-200 mt-1 mb-1'>
                    <div className='w-100 text-bold'>Semana trasplante</div>
                    <select className='form-control form-control-sm shadow-sm border' value={paginer.semana} onChange={(e) => {
                        let pag = { ...paginer, semana: e.target.value, flor: "", variedad: "", color: "" };
                        getRegistros(pag);
                    }}>
                        {semanas.map((s, i) => <option key={i + "semana"} value={s} >{s}</option>)}
                    </select>
                </div>

                {['flores', 'variedades', 'colores'].map((key, i) => {
                    let filtro = filtros[key];
                    let filtro_key = ['flor', 'variedad', 'color'][i];
                    return (
                        <div key={i + "filtro"} className='bw-200 mt-1 mb-1'>
                            <div className='w-100 text-bold'>{key.toUpperCase()}</div>
                            <select className='form-control form-control-sm shadow-sm border' value={paginer[filtro_key]} onChange={(e) => {
                                let pag = { ...paginer, [filtro_key]: e.target.value };
                                getRegistros(pag);
                            }}>
                                <option value={''} >Sin filtrar</option>
                                {filtro.map((val, j) => <option key={i + "semana" + j} value={val.id} >{val.nombre}</option>)}
                            </select>
                        </div>
                    )
                })}

                <div className='w-100 mt-2 p-0 mb-0' style={{ maxHeight: "70vh", overflow: "auto" }}>
                    <table className='table table-sm table-hover'>
                        <thead>
                            <tr>
                                {headsTable.map((e, i) => <th key={i} scope='col' className={'nowrap bg-black text-white text-center'
                                    + (i === 0 ? ' round-left-xxl' : i === headsTable.length - 1 ? ' round-right-xxl' : ' border border-white')
                                }>{e}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((dt, i) => <tr key={i + "reg"} scope='col' className='nowrap pointer' onClick={() => { setregistroEdicion(dt); setagregar(true) }}>
                                {keys.map((k, j) => <td key={j + "col" + i} className={'nowrap ' + (k === "bloque" ? "text-bold text-start" : " text-center")}>
                                    {get(dt, k)}
                                </td>)}
                            </tr>)}
                        </tbody>
                    </table>
                </div>

            </div>
            {agregar && <AgregarSiembraCampo close={cerrarYguardar} registroEdicion={registroEdicion} />}
            {loader && ldr}
            <VainillaDialog data={dialog} />
        </div>
    )
}

export default SiembraDirecta;